import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { Constant } from "src/app/common/constant/constant";
import { ApiService } from '../../services/api/api.service';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { ThreadService } from 'src/app/services/thread/thread.service';
import { ProductMatrixService } from 'src/app/services/product-matrix/product-matrix.service';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import {AllDataApiService} from "../../services/all-data-api/all-data-api.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  // accessLevel : any = ['threads'];
  public user: any;
  public domainId;
  public userId;
  public roleId;
  public apiKey: string = Constant.ApiKey;
  public platformId = localStorage.getItem('platformId');
  rolesData: any = [];
  maper: any = {
    threads: "Threads",
    documents: "Tech Info",
    gts: "GTS",
    knowledgearticles: "Knowledge Articles",
    parts: "Parts",
    inventory: "Inventory",
    "workstreams-page": "Workstream",
  };
  public loading$ = new BehaviorSubject<boolean>(false);
  
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private apiService: ApiService,
    private threadApi: ThreadService,
    private probService: ProductMatrixService,
    private allDataApiService: AllDataApiService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      this.loading$.next(true);
      const user = this.authenticationService.userValue;
      this.allDataApiService.handleAllDataRedirection();
      if (user) {
        let accountPages = ['/account-subscription'];
        this.domainId = user['domain_id'];
        this.userId = user['Userid'];
        this.apiService.threadViewPublicPage = false;
        this.apiService.docViewPublicPage = false;
        this.apiService.kaViewPublicPage = false;
        this.roleId = user['roleId'];
        this.rolesData = JSON.parse(localStorage.getItem("param"));
        // logged in so return true
        let currUrl = state.url.split('/');
        let type = "View";
        let urlLen = currUrl.length;
        if (urlLen > 2) {
          if (currUrl[2] == 'manage' && currUrl[3] == undefined) {
            type = "Create";
          }
          /*if(currUrl[3]!= undefined && currUrl[3] =='edit'){
            type = "Edit";
          }*/
        }

        let isBusinessPartner:any = localStorage.getItem('isBusinessPartner');
        isBusinessPartner = (isBusinessPartner && isBusinessPartner != undefined) ? isBusinessPartner : 0;
        if(this.domainId == 526 && isBusinessPartner == 1 && (currUrl[1] != 'repair-order' && currUrl[1] != 'support-request')) {
          return this.router.navigate(["/support-request"]);
        }

        if (this.apiService.enableAccessLevel) {
          if (this.rolesData) {
            let filtered = this.rolesData.items.find(
              (item) =>
                // item.slugName == this.maper[route.routeConfig.path]
                // item.slugName == this.maper[route.routeConfig.path]
                item.slugName == currUrl[1]
            );
            if (filtered !== undefined) {
              let newFiltered = filtered?.pageAccess.find(
                (item) => item.name == type
              );
              let permission = newFiltered?.roles?.find(
                (role) => role.id == this.roleId
              );
              if (permission?.access == 0) {
                this.loading$.next(false);
                return this.router.navigate(["/no-permission"]);
              } else {
                /*if (platformId != "1") {
                  let returnVal = this.authenticationService.checkDomain();
                  return returnVal;
                } else {*/
                // if ([63, 336].includes(this.domainId)) {
                  let subscriptionActive = await this.checkSubscription(state.url);
                  if (!subscriptionActive) {
                    this.loading$.next(false);
                    return this.router.navigate(["/landing-page"]);
                  } else {
                    this.loading$.next(false);
                    resolve(true);
                    return true;
                  }
                // } else {
                //   if (accountPages.includes(state.url)) {
                //     return this.router.navigate(["/landing-page"]);
                //   } else {
                //     resolve(true);
                //     return true;
                //   }
                // }
                /*}*/
              }
            } else {
              /*if (platformId != "1") {
                let returnVal = this.authenticationService.checkDomain();
                return returnVal;
              } else {*/
              // if ([63, 336].includes(this.domainId)) {
                let subscriptionActive = await this.checkSubscription(state.url);
                if (!subscriptionActive) {
                  this.loading$.next(false);
                  return this.router.navigate(["/landing-page"]);
                } else {
                  this.loading$.next(false);
                  resolve(true);
                  return true;
                }
              // } else {
              //   if (accountPages.includes(state.url)) {
              //     return this.router.navigate(["/landing-page"]);
              //   } else {
              //     resolve(true);
              //     return true;
              //   }
              // }
              /* }*/
            }
          } else {
            /*if (platformId != "1") {
              let returnVal = this.authenticationService.checkDomain();
              return returnVal;
            } else {*/
            // if ([63, 336].includes(this.domainId)) {
              let subscriptionActive = await this.checkSubscription(state.url);
              if (!subscriptionActive) {
                this.loading$.next(false);
                return this.router.navigate(["/landing-page"]);
              } else {
                this.loading$.next(false);
                resolve(true);
                return true;
              }
            // } else {
            //   if (accountPages.includes(state.url)) {
            //     return this.router.navigate(["/landing-page"]);
            //   } else {
            //     resolve(true);
            //     return true;
            //   }
            // }
            /*}*/
          }
        }
        else {
          // if ([63, 336].includes(this.domainId)) {
            let subscriptionActive = await this.checkSubscription(state.url);
            if (!subscriptionActive) {
              this.loading$.next(false);
              return this.router.navigate(["/landing-page"]);
            } else {
              this.loading$.next(false);
              resolve(true);
              return true;
            }
          // } else {
          //   if (accountPages.includes(state.url)) {
          //     return this.router.navigate(["/landing-page"]);
          //   } else {
          //     resolve(true);
          //     return true;
          //   }
          // }
        }
      }


      if (window.location.host == 'tac-beta.cbaconnect.com') {
        window.open('sso/index.php?sso', '_self');
      }
      if (window.location.host == 'tac.cbaconnect.com') {
        window.open('sso/index.php?sso', '_self');
      }

      // not logged in so redirect to login page with the return url
      //this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
      let authteam = '';
      if (window.location.host == Constant.knowledgeForumHostName) {
        authteam = '1';
      }
      else {
        authteam = localStorage.getItem('teamSystem');
      }

      if (authteam) {
        this.router.navigate(['auth/integration']);
      }
      else {
        this.router.navigate(['auth']);
      }
      this.loading$.next(false);
      return false;
    });
  }

  async checkSubscription(url) {
    try {
      // let user: any = await this.probService.getUserProfile({ api_key: "dG9wZml4MTIz", countryId: "", domain_id: this.domainId, user_id: this.userId }).toPromise();
      let user: any = await this.probService.getUserSubscribedetails({ api_key: "dG9wZml4MTIz", countryId: "", domain_id: this.domainId, user_id: this.userId }).toPromise();
      if((user.hasOwnProperty('dataSubscription') && user.dataSubscription && user.isVerified) || (user.hasOwnProperty('isDevUserSubscription') && user.isDevUserSubscription)) {
        let subscription = await this.threadApi.apiGetSubscription({ userId: this.userId, domainId: this.domainId, isProductSubscriber: parseInt(user.isProductSubscriber), shopId: parseInt(user.businessId), subscriptionType: user.subscrptionType }).toPromise();
        
        if (this.domainId == 395 || this.domainId == 488) {
          let subscriptionBMW = await this.threadApi.apiGetSubscription({ userId: this.userId, domainId: this.domainId, isProductSubscriber: parseInt(user.isProductSubscriber), shopId: parseInt(user.businessId), subscriptionType: user.subscrptionType, subscriptionBrand: 'BMW' }).toPromise();
          let subscriptionVAG = await this.threadApi.apiGetSubscription({ userId: this.userId, domainId: this.domainId, isProductSubscriber: parseInt(user.isProductSubscriber), shopId: parseInt(user.businessId), subscriptionType: user.subscrptionType, subscriptionBrand: 'VAG' }).toPromise();
          if (subscriptionBMW?.data?.subscription && subscriptionVAG?.data?.subscription) {
            if (subscriptionBMW?.data?.subscription?.status == 'canceled') {
              if (subscriptionVAG?.data?.subscription?.status == 'canceled') {
                subscription = subscriptionBMW
              } else {
                subscription = subscriptionVAG
              }
            } else {
              subscription = subscriptionBMW
            }
          } else if (subscriptionBMW?.data?.subscription) {
            subscription = subscriptionBMW
          } else if (subscriptionVAG?.data?.subscription) {
            subscription = subscriptionVAG
          }
        }

        let subscriptionDetails = subscription.data.subscription;
        let currentTime = Date.now();
        this.apiService.expiredSubscription = (user.dataSubscription == 1 && user.isDataSubscribExpired == 1) ? true : false;
        this.apiService.subscriptionInfo = subscriptionDetails;
        this.setupSubscriptionData(subscription);
        if ((subscriptionDetails.subscription_id != 'trial' && subscriptionDetails?.status == 'active') ||
            (subscriptionDetails.subscription_id == 'trial' && subscriptionDetails?.remaining_days > 0)) {
          return true;
        } else {
          if(!['/landing-page', '/account-subscription'].includes(url)) {
            //return false;
            return true;
          } else {
            return true;
          }
        }
      } else {
        if(url == '/account-subscription') {
          return false;
        } else {
          return true;
        }
      }
    }
    catch (e) {
      return false;
    };
  }

  setupSubscriptionData(res) {
    let subscriptionDetails = res.data?.subscription;
    let subscribedProduct = [];
    subscribedProduct['cancelDate'] = subscriptionDetails?.cancel_date ? moment(parseFloat(subscriptionDetails?.cancel_date) * 1000).format('MMMM Do YYYY') : null;
    subscribedProduct['endDate'] = moment(parseFloat(subscriptionDetails?.end_date) * 1000).format('MMMM Do YYYY');
    subscribedProduct['startDate'] = moment(parseFloat(subscriptionDetails?.start_date) * 1000).format('MMMM Do YYYY');
    subscribedProduct['status'] = (subscriptionDetails?.subscription_id != 'trial' ? subscriptionDetails?.status : (subscriptionDetails?.remaining_days ? 'active' : 'expired'));
    subscribedProduct['name'] = subscriptionDetails?.subscription_name;
    subscribedProduct['title'] = subscriptionDetails?.subscription_title;
    subscribedProduct['remainingDays'] = subscriptionDetails?.remaining_days;
    subscribedProduct['amount'] = subscriptionDetails?.subscription_amount;
    subscribedProduct['period'] = subscriptionDetails?.subscription_period;
    this.apiService.subscribedProduct = subscribedProduct;
  }
}
